import Service from "../service";

const Status = {
    getOrderStatus() {
        return Service.get("/order-status");
    },
    getInvoiceStatus() {
        return Service.get("/invoice-status");
    },
    getPosition() {
        return Service.get("/position_all");
    },
    getEmployeeType() {
        return Service.get("/employee-type");
    },
    getShiftWork() {
        return Service.get("/shift-work");
    },
    getShiftWorkEmployee() {
        return Service.get("/shift_work_employee");
    },
    getProvince() {
        return Service.get('/provinces');
    },
    getGeography() {
        return Service.get('/geography');
    },
    getProvinceFromGeography(area_id) {
        return Service.post('/provinces_from_area?geography=' + area_id);
    },
    getRateBonusSaleAll() {
        return Service.get("/bonus_sale_all");
    },
    searchDistricts(province_code) {
        return Service.post('/search-districts?province_code=' + province_code);
    },
    searchSubDistricts(district_code) {
        //console.log('/sub_districts-search?district_code='+district_code);
        return Service.post('/sub_districts-search?district_code=' + district_code);
    },
    getMaterialType() {
        return Service.get("/material-type");
    },
    getMaterialCode() {
        return Service.get("/material-code");
    },
    getSizeWrapProduct() {
        return Service.get("/size_wrap_products");
    },
    getBankType() {
        return Service.get("/bank_type");
    },
    getBankBranch() {
        return Service.get("/branch_bank");
    },
    getPassportType() {
        return Service.get('/passport_type');
    },
    getWorkTime() {
        return Service.get('/get_work_time');
    },
    uploadFile(data) {
        return Service.post('/get_path_file', data);
    },
    uploadFiles(data) {
        //console.log(data)
        return Service.post('/get_path_files', data);
    },
    getRateTax(data) {
        return Service.get('rate_tax', data);
    }
};
export default Status;
